<template>
  <div class="container vh-70">
    <div class="row justify-content-center align-items-center">
      <div class="col-4 text-center">
        <CIcon name="cil-lock-locked" size="8xl" />
        <h1>Ocurrió un error</h1>
        <p>Elige una opción del menú o:</p>
        <router-link to="/dashboard" custom v-slot="{ href, navigate }">
          <a
            :href="href"
            class="btn btn-primary"
            @click="navigate"
          >
            Volver al inicio
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Page_500",
};
</script>
